<template>
  <div
    class="activity-dialog bonus-reward-mask"
    :class="[$i18n.locale, isCSSMobile ? 'mobile' : 'pc']"
    @click.self="close"
  >
    <div class="bonus-reward-popup">
      <div
        class="bonus-reward-content"
        :data-text="$t(`text.activityPopup_${gameId}`)"
        v-html="$t(`text.activityPopup_${gameId}`)"
      ></div>
      <div class="bonus-reward-btn-wrap">
        <button
          class="bonus-reward-btn bold"
          :class="{ pressing: isPressed }"
          @touchstart.passive="isPressed = true"
          @touchend.passive="isPressed = false"
          @touchcancel.passive="isPressed = false"
          @click="close"
        >
          <div class="txt" :data-text="$t('game.confirm')">{{ $t('game.confirm') }}</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'BonusRewardPopup',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isPressed: false,
    }
  },
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      isCSSMobile: (state) => state.app.isCSSMobile,
    }),
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.bonus-reward-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.bonus-reward-popup {
  &.AR {
    direction: rtl;
  }
  width: 345px;
  height: 332px;
  margin-top: -85px;
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}
.bonus-reward-content {
  width: 290px;
  height: 92px;
  overflow-y: auto;
  position: absolute;
  top: 117px;
  left: 27.5px;
  font-size: 13px;
  color: #b7efff;
  line-height: 1.55;

  &::-webkit-scrollbar {
    display: none;
  }
}
.bonus-reward-btn-wrap {
  width: 145.5px;
  height: 46px;
  position: absolute;
  top: 276px;
  left: 99.5px;
  .bonus-reward-btn {
    width: 100%;
    height: 100%;
    text-align: center;
    color: #ffffff;
    line-height: 46px;
    font-size: 14.5px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    touch-action: manipulation;

    &:active,
    &.pressing {
      transform: scale(0.96);
    }
  }
}
</style>
